import {
  formatSecondsToDuration,
  formatTimesheetDates,
  isPastApproval,
} from '@timekeeping/services';
import { ReviewWorkerTimesheetFragment } from '@common/graphql/schema';
import { useMemo } from 'react';

export const useWorkerTimesheetStats = (
  timesheet: ReviewWorkerTimesheetFragment | undefined
) => {
  return useMemo(
    () => [
      {
        title: formatTimesheetDates(
          timesheet?.timesheet.startDate,
          timesheet?.timesheet.endDate,
          timesheet?.timesheet.timeZone,
          true
        ),
        showPastApproval: isPastApproval(timesheet),
        counts: timesheet?.hoursSummary.map(({ name, totalSeconds }) => ({
          label: name,
          value: formatSecondsToDuration(totalSeconds),
        })),
      },
    ],
    [timesheet]
  );
};
